import dynamic from 'next/dynamic'

const FroalaEditorView = dynamic(import('react-froala-wysiwyg/FroalaEditorView'), {
  ssr: false
})

const FroalaView = (props) => {
  return (
    <>
      <FroalaEditorView {...props} />
      <style jsx global>{`
        .fr-view {
          word-break: break-word;
        }
      `}</style>
    </>
  )
}

export default FroalaView
